import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';
import { priorities } from 'constants/common';
import SvgIcon from '@mui/material/SvgIcon';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const PriorityBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'priority',
})(({ theme, priority }) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: theme.typography.fontWeightMedium,
  ...(priority === 'LOW' && {
    color: theme.palette.priorities.low,
  }),
  ...(priority === 'MEDIUM' && {
    color: theme.palette.priorities.medium,
  }),
  ...(priority === 'HIGH' && {
    color: theme.palette.priorities.high,
  }),
  ...(priority === 'URGENT' && {
    color: theme.palette.priorities.urgent,
  }),
}));

const IconBox = styled(SvgIcon, {
  shouldForwardProp: (prop) => prop !== 'iconSize',
})(({ theme, iconSize }) => ({
  marginRight: theme.spacing(1),
  fontSize: iconSize,
  verticalAlign: 'middle',
}));

const Priority = ({ priority, fontSize, placeholder, gutterBottom }) => {
  const priorityIcon = priorities.find((el) => el.value === priority);

  return (
    <Typography variant="h6" gutterBottom={gutterBottom}>
      <PriorityBox priority={priority} sx={{ fontSize }}>
        {priority ? (
          <>
            <IconBox component={priorityIcon?.icon} iconSize={fontSize} />
            {i18n.t(`priorities.${priority}`)}
          </>
        ) : (
          <Typography>{placeholder}</Typography>
        )}
      </PriorityBox>
    </Typography>
  );
};

Priority.propTypes = {
  fontSize: PropTypes.number,
  gutterBottom: PropTypes.bool,
  placeholder: PropTypes.string,
  priority: PropTypes.oneOf(['LOW', 'HIGH', 'MEDIUM', 'URGENT']).isRequired,
};

Priority.defaultProps = {
  fontSize: 13,
  placeholder: '--',
  gutterBottom: true,
};

export default Priority;
